import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Clock, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function BookingSuccess() {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    api.get(`/bookings/${id}`).then((r) => setBooking(r.data));
  }, [id]);

  if (!booking) return <div className="p-20 text-center text-brand-soft/60">Loading…</div>;

  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-12 py-16 sm:py-24" data-testid="booking-success-page">
      <div className="bg-white border border-brand-maroon/10 rounded-3xl p-10 sm:p-12 text-center">
        <CheckCircle2 className="w-14 h-14 text-brand-olive mx-auto" />
        <div className="eyebrow mt-5">Booking received</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-brand-soft mt-3">Thanks, {booking.pet_parent_name.split(" ")[0]}!</h1>
        <p className="text-brand-soft/70 mt-4 leading-relaxed">
          We&apos;ve received your booking for <strong>{booking.event_title}</strong>. Once our team verifies the payment,
          you&apos;ll receive a confirmation at <strong>{booking.email}</strong>.
        </p>
        <div className="inline-flex items-center gap-2 mt-6 bg-brand-mustard/15 text-brand-maroon px-4 py-2 rounded-full text-xs font-semibold">
          <Clock className="w-4 h-4" /> Payment status: {booking.payment_status}
        </div>

        <div className="text-left bg-brand-ivory rounded-2xl p-6 mt-8">
          <div className="font-serif text-xl text-brand-soft mb-3">Summary</div>
          <div className="space-y-2 text-sm">
            {booking.breakdown.map((b, i) => (
              <div key={i} className="flex justify-between">
                <span className="text-brand-soft/80">{b.label} {b.qty > 1 && <>× {b.qty}</>}</span>
                <span className="font-medium">₹{b.amount}</span>
              </div>
            ))}
            <div className="h-px bg-brand-maroon/10 my-3" />
            <div className="flex justify-between text-base">
              <span className="font-medium">Total paid</span>
              <span className="font-serif text-2xl text-brand-maroon">₹{booking.total_amount}</span>
            </div>
          </div>
          <div className="mt-4 text-xs text-brand-soft/60">Reference: {booking.payment_ref}</div>
        </div>

        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/events" className="btn-outline-furshala">Back to events</Link>
          <Link to="/community" className="btn-primary-furshala inline-flex items-center gap-2">Join community <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </div>
  );
}
